'use strict';

var log = require('../../log/Log').channel('SetupNetworkController');

angular.module('inara').controller('SetupNetworkController', SetupNetworkController);

SetupNetworkController.$inject = ['$scope', '$state', 'DeviceService', '$timeout',
                                  'gettextCatalog'];

function SetupNetworkController($scope, $state, DeviceService, $timeout,
                                gettextCatalog) {
    var vm = this;
    var enableEthernetTimeout = null;

    log.info('initializing');

    $scope.$on('$ionicView.beforeEnter', function() {
        // We need to try to enable the ethernet interface every time the view
        // enters so we can show the connected status.  If no ethernet network
        // is currently present, enabling the ethernet interface will return an
        // error, so we need to set a timeout to try again after a while (to
        // account for ethernet later being plugged in so we can then enable
        // the interface to show the status.)
        enableEthernet();

        // We also enable wifi, just in case an earlier version of Inara had it
        // disabled, since we formerly enabled the selected interface and 
        // disabled the other interface.
        DeviceService.setWifiEnabled(true);
    });

    $scope.$on('$stateChangeSuccess', function(event, toState, toParams, 
                                               fromState, fromParams) {
        if (fromState.name === 'setup.network' && 
            enableEthernetTimeout !== null) {
            $timeout.cancel(enableEthernetTimeout);
            enableEthernetTimeout = null;
        }
    });

    function enableEthernet() {
        log.debug('enabling ethernet interface to check status');
        DeviceService.setEthernetState(true).catch(function(error) {
            log.debug('ethernet network not detected');
            enableEthernetTimeout = $timeout(function() {
                enableEthernet();
            }, 5000);
        });        
    }

    /// Title bar for setup select network connection page
    vm.getViewTitle = function() { return gettextCatalog.getString('Select Network Connection'); };

    vm.getWiredConnectionStatus = function() {
        return DeviceService.getNetworkConnection() === 'ethernet';
    };
    vm.getWiredConnectionStatusMsg = function() {
        /// Status message in setup for wired network connection
        return DeviceService.getNetworkConnection() === 'ethernet' ? 
            gettextCatalog.getString('Connected') : gettextCatalog.getString('Not connected');
    };

    vm.networkConnections = {
        /// Button label in setup for wired network connection
        wired: { getLabel: function() { return gettextCatalog.getString('Wired'); } },
        /// Button label in setup for wireless network connection
        wifi: { getLabel: function() { return gettextCatalog.getString('Wireless'); } }
    };

    vm.continue = function (network) {
        delete $scope.setup.network;
        $scope.setup.network = { 
            type: network,
            label: vm.networkConnections[network].getLabel()
        };
        if (network === 'wifi') {
            $scope.goTo('setup.wifi');
        }
        else {
            $scope.goTo('setup.pairing');
        }
    };
}

module.exports = SetupNetworkController;
